module.exports = __webpack_public_path__ + "img/banner_pt.3237f864.jpg";